const generateId = () => Math.random().toString(36).substr(2, 9);

export default [
  {
    label: 'Analytics',
    name: 'analytics',
    component: 'group',
    description: 'Enable Shopify analytics',
    fields: [
      {
        label: 'Enabled',
        name: 'enabled',
        component: 'toggle',
        description: 'Ensure "NEXT_PUBLIC_SHOPIFY_SHOP_ID" is set as an env var',
        toggleLabels: {
          true: 'On',
          false: 'Off',
        },
        defaultValue: true,
      },
    ],
  },
  {
    label: 'Geo Localization',
    name: 'geoLocalization',
    component: 'group',
    fields: [
      {
        label: 'Enable Country Recommendation',
        component: 'toggle',
        name: 'enableNotification',
        description:
          "Enables a modal window that notifies the customer about being on a country different to their own, if disabled the store will pick customer's location by default",
      },
      {
        label: 'Modal title',
        component: 'text',
        name: 'modalTitle',
        description:
          "Title for the modal shown to the customer, use keyword [currentCountry] to show the current store country name use [customerCountry] to show the country where they are located at, use [storeCurrency] to display store's current currency, use [customerCurrency] to show the customer's country currency (example USD $)",
      },
      {
        label: 'Modal description',
        component: 'markdown',
        name: 'modalBody',
        description:
          "Body of the modal shown to the customer, use keyword [currentCountry] to show the current store country name, use [customerCountry] to show the country where they are located at, use [storeCurrency] to display store's current currency, use [customerCurrency] to show the customer's country currency (example USD $)",
      },
    ],
  },
  {
    label: 'Discount Banner',
    name: 'discountBanner',
    component: 'group',
    description: 'Discount Banner Settings',
    fields: [
      {
        component: 'toggle',
        name: 'toggleAutoRotate',
        label: 'Auto Rotate Toggle',
        description:
          'Describes if banner is auto-rotating when 2 messages populated.',
        toggleLabels: {
          true: 'Enable',
          false: 'Disable',
        },
        defaultValue: true,
      },
      {
        component: 'toggle',
        name: 'toggleAutoRotateInt',
        label: 'Int Auto Rotate Toggle',
        description:
          'Int - Describes if banner is auto-rotating when 2 messages populated.',
        toggleLabels: {
          true: 'Enable',
          false: 'Disable',
        },
        defaultValue: true,
      },
      {
        component: 'group-list',
        name: 'messages',
        label: 'Discount Banner Messages',
        description: 'Discount banner messages for desktop and mobile.',
        fields: [
          {
            component: 'textarea',
            name: 'messageMobile',
            label: 'Mobile Message',
          },
          {
            component: 'textarea',
            name: 'messageDesktop',
            label: 'Desktop Message',
          },
        ],
      },
      {
        component: 'group-list',
        name: 'messagesInt',
        label: 'Int Discount Banner Messages',
        description:
          'International discount banner messages for desktop and mobile.',
        fields: [
          {
            component: 'textarea',
            name: 'messageMobile',
            label: 'Mobile Message',
          },
          {
            component: 'textarea',
            name: 'messageDesktop',
            label: 'Desktop Message',
          },
        ],
      },
      {
        component: 'select',
        name: 'bgColor',
        label: 'Background Color',
        description:
          'For discount banner background color, select one from preselected brand colors.',
        options: [
          { label: 'Grey', value: 'grey-1' },
          { label: 'Pink', value: 'primary-2' },
          { label: 'Green', value: 'quaternary-1' },
          { label: 'Blue 1', value: 'quinary-1' },
          { label: 'Blue 2', value: 'quinary-2' },
          { label: 'Air Dry Cream', value: 'stylers-1' },
          { label: 'Sculpting Cream', value: 'stylers-2' },
          { label: 'Texture Foam', value: 'stylers-3' },
          { label: 'Sleek Stick', value: 'stylers-4' }
        ],
        defaultValue: 'quinary-2',
      },
      {
        component: 'select',
        name: 'bgColorInt',
        label: 'Int Background Color',
        description:
          'International - For discount banner background color, select one from preselected brand colors.',
        options: [
          { label: 'Grey', value: 'grey-1' },
          { label: 'Pink', value: 'primary-2' },
          { label: 'Green', value: 'quaternary-1' },
          { label: 'Blue 1', value: 'quinary-1' },
          { label: 'Blue 2', value: 'quinary-2' },
          { label: 'Air Dry Cream', value: 'stylers-1' },
          { label: 'Sculpting Cream', value: 'stylers-2' },
          { label: 'Texture Foam', value: 'stylers-3' },
          { label: 'Sleek Stick', value: 'stylers-4' }
        ],
        defaultValue: 'quinary-2',
      },
      {
        component: 'group-list',
        name: 'overrides',
        label: 'Discount overrides',
        description:
          'Describes the text cases when a discount code is applied on the cart, this overrides will apply to both INTL and US customers the same',
        fields: [
          {
            component: 'text',
            name: 'discountCode',
            label: 'Discount code reference',
            description:
              'Discount code that needs to be present on the cart in order to trigger this override',
          },
          {
            component: 'textarea',
            name: 'messageMobile',
            label: 'Mobile Message',
          },
          {
            component: 'textarea',
            name: 'messageDesktop',
            label: 'Desktop Message',
          },
        ],
      },
    ],
  },
  {
    label: 'Global Share Image',
    name: 'globalShareImage',
    component: 'group',
    fields: [
      {
        label: 'Image',
        name: 'image',
        component: 'image',
        description: 'Recommended image size: 1200 x 628px',
      },
    ],
  },
  {
    label: 'Header',
    name: 'header',
    component: 'group',
    fields: [
      {
        label: 'Logo',
        name: 'logo',
        component: 'image',
      },
      {
        label: 'Logo Alt Text',
        name: 'tagline',
        component: 'text',
        description: 'Add descriptive text for ADA',
      },
      {
        label: 'Rewards Link in Header',
        name: 'rewards_enabled',
        component: 'toggle',
        description: 'Toggle Off if wanting to display custom CTA below instead.',
        toggleLabels: {
          true: 'On',
          false: 'Off',
        },
        defaultValue: true,
      },
      {
      label: 'CTA',
      name: 'cta',
      component: 'group',
      description: 'If Rewards Link in Header is toggled off then CTA will display instead',
      fields: [
        {
          label: 'CTA URL',
          name: 'link',
          component: 'link',
          description: 'Recommended Max Character count: 17',
        },
        {
          component: 'select',
          name: 'style',
          label: 'Cta Style',
          description: 'CTA Style and link title will be applied the same for desktop and mobile',
          options: [
              { label: 'Primary', value: 'button button--primary inline-block' },
              {
                label: 'Secondary',
                value: 'button button--secondary inline-block',
              },
              { label: 'Focus Link', value: 'focus-link' },
              {
                label: 'checkout',
                value: 'button button--checkout inline-block',
              },
            ],
            defaultValue: 'button button--primary inline-block',
          },
        ],
      },
    ],
  },
  {
    label: 'Header Menu',
    name: 'header_menu',
    component: 'group-list',
    itemProps: {
      label: '{{item.link.text}}',
    },
    fields: [
      {
        label: 'Link',
        name: 'link',
        component: 'link',
      },
      {
        label: 'Column',
        name: 'column',
        component: 'group-list',
        fields: [
          {
            component: 'toggle',
            name: 'enable_column',
            label: 'Enable',
            description: 'Enable Column',
            defaultValue: true,
          },
          {
            component: 'toggle',
            name: 'featured_column',
            label: 'Featured Column',
            description:
              'Doubles the column width and allows for links images to be placed on top of the links',
            defaultValue: false,
          },
          {
            label: 'Menu',
            name: 'menu',
            component: 'group-list',
            itemProps: {
              label: '{{item.link.text}}',
            },
            fields: [
              {
                component: 'toggle',
                name: 'open_column',
                label: 'Enable',
                description: 'Mobile Menu- Show Menu Dropdown Open by Default',
                defaultValue: false,
              },
              {
                label: 'Link',
                name: 'link',
                component: 'link',
              },
              {
                label: 'Link Icon',
                name: 'link_icon',
                component: 'image',
                description:
                  'Recommended Icon Size: 50px x 50px (square dimension) for regular icons next to the text',
              },
              {
                label: 'Child Menu',
                name: 'child_menu',
                component: 'group-list',
                itemProps: {
                  label: '{{item.link.text}}',
                },
                fields: [
                  {
                    label: 'Link',
                    name: 'link',
                    component: 'link',
                  },
                  {
                    label: 'Link Icon',
                    name: 'link_icon',
                    component: 'image',
                    description:
                      'Recommended Icon Size: 50px x 50px (square dimension) and 200px x 200px for featured columns where icons are placed on top of the text',
                  },
                  {
                    component: 'color',
                    name: 'link_color',
                    label: 'Custom Color',
                    description: 'Custom Link color',
                  },
                  {
                    label: 'Promo Text',
                    name: 'promo_text',
                    component: 'text',
                    description: 'Add Promo Text',
                  },
                  {
                    label: 'Hover Image',
                    name: 'link_hover_image',
                    component: 'image',
                    description: 'Recommended Icon Size: 1392px x 920px',
                  },
                  {
                    component: 'toggle',
                    name: 'bold_underline',
                    label: 'Bold and Underline',
                    description: 'Make menu item bold and underline',
                    defaultValue: false,
                  },
                ],
              },
            ],
          },
          {
            label: 'CTA',
            name: 'cta',
            component: 'group',
            fields: [
              {
                label: 'CTA Image',
                name: 'image',
                component: 'image',
              },
              {
                label: 'CTA Title',
                name: 'title',
                component: 'text',
              },
              {
                label: 'CTA URL',
                name: 'url',
                component: 'text',
              },
            ],
          },
        ],
      },
    ],
  },
  {
    label: 'Mobile Sticky Navigation',
    name: 'mobileStickyNavigation',
    component: 'group-list',
    itemProps: {
      label: '{{item.link.text}}',
    },
    fields: [
      {
        label: 'Link',
        name: 'link',
        component: 'link',
      },
    ],
  },
  {
    label: 'Footer',
    name: 'footer',
    component: 'group',
    fields: [
      {
        label: 'Tagline',
        name: 'tagline',
        component: 'text',
      },
      {
        label: 'Footer Menu 1',
        name: 'footerMenu1',
        component: 'group-list',
        itemProps: {
          label: '{{item.link.text}}',
        },
        fields: [
          {
            label: 'Link',
            name: 'link',
            component: 'link',
          },
        ],
      },
      {
        label: 'Footer Menu 2',
        name: 'footerMenu2',
        component: 'group-list',
        itemProps: {
          label: '{{item.link.text}}',
        },
        fields: [
          {
            label: 'Link',
            name: 'link',
            component: 'link',
          },
        ],
      },
      {
        label: 'Footer Small Menu',
        name: 'footerSmallMenu',
        component: 'group-list',
        itemProps: {
          label: '{{item.link.text}}',
        },
        fields: [
          {
            label: 'Link',
            name: 'link',
            component: 'link',
          },
        ],
      },
      {
        label: 'Email Subscribe',
        name: 'email',
        component: 'group',
        fields: [
          {
            label: 'Title',
            name: 'title',
            component: 'text',
          },
          {
            label: 'Klaviyo List ID',
            name: 'listId',
            component: 'text',
          },
          {
            label: 'Button Text',
            name: 'buttonText',
            component: 'text',
          },
          {
            label: 'Success Message',
            name: 'successMessage',
            component: 'text',
          },
        ],
      },
    ],
  },
    {
    label: 'Product',
    name: 'product',
    component: 'group',
    fields: [
      {
        component: 'group',
        name: 'productValueProps',
        label: 'Value Props',
        fields: [
          {
            label: 'Value Icon 1',
            name: 'value_icon_1',
            component: 'image',
            description:
              'Recommended SVG Icon Size: 24px x 24px (square dimension)',
          },
          {
            label: 'Value Promo Text 1',
            name: 'value_text_1',
            component: 'text',
            description: 'Value Description (recommended 24 characters)',
          },
          {
            label: 'Value Icon 2',
            name: 'value_icon_2',
            component: 'image',
            description:
              'Recommended SVG Icon Size: 24px x 24px (square dimension)',
          },
          {
            label: 'Value Promo Text 2',
            name: 'value_text_2',
            component: 'text',
            description: 'Value Description (recommended 24 characters)',
          },
          {
            label: 'Value Icon 3',
            name: 'value_icon_3',
            component: 'image',
            description:
              'Recommended SVG Icon Size: 24px x 24px (square dimension)',
          },
          {
            label: 'Value Promo Text 3',
            name: 'value_text_3',
            component: 'text',
            description: 'Value Description (recommended 24 characters)',
          },
        ],
      },
      {
        label: 'Coming Soon Email Subscribe',
        name: 'productEmail',
        component: 'group',
        fields: [
          {
            label: 'Title',
            name: 'title',
            component: 'text',
          },
          {
            label: 'Klaviyo List ID',
            name: 'listId',
            component: 'text',
          },
          {
            label: 'Button Text',
            name: 'buttonText',
            component: 'text',
          },
          {
            label: 'Success Message',
            name: 'successMessage',
            component: 'text',
          }
        ],
      },
    ],
  },
  {
    label: 'Cart Page',
    name: 'cartPage',
    component: 'group',
    fields: [
      {
        label: 'Cart Empty Message',
        name: 'cartEmptyMessage',
        component: 'text',
        defaultValue: 'Oops! Your cart is currently empty.',
      },
      {
        label: 'CTA',
        name: 'cta',
        component: 'group',
        fields: [
          {
            label: 'CTA Title',
            name: 'title',
            component: 'text',
            defaultValue: 'continue shopping',
          },
          {
            label: 'CTA URL',
            name: 'url',
            component: 'text',
            defaultValue: '/',
          },
        ],
      },
    ],
  },
  {
    label: 'Side Cart',
    name: 'sideCart',
    component: 'group',
    fields: [
      {
        label: 'Free Shipping Threshold',
        name: 'freeShippingThreshold',
        component: 'group',
        fields: [
          {
            label: 'Free Shipping Threshold',
            name: 'Threshold',
            component: 'number',
            description:
              'Enter a dollar amount. Free shipping will be applied when cart total meets the threshold.',
            defaultValue: 0,
          },
          {
            label: 'Free shipping product information',
            name: 'information',
            component: 'text',
            description:
              'Example: away from our free mini hair mask OR away from free shipping. (use text [TOTAL] for variable for left amount)',
            defaultValue:
              'You are only [TOTAL] away from free shipping. (subscription orders ship free)',
          },
          {
            label: 'Message when threshold is met',
            name: 'message',
            component: 'text',
            description: "Example: Yay! you're getting a free mini hair mask!",
            defaultValue: "Yay! You're getting free shipping!",
          },
          {
            label: 'Enable subscription shipping message',
            name: 'enableSubscriptionText',
            description:
              'If enabled, carts with subscriptions will show the free shipping message below',
            component: 'toggle',
            toggleLabels: {
              true: 'Enabled',
              false: 'Disabled',
            },
          },
          {
            label: 'Subscription shipping message',
            name: 'subscriptionThresoldText',
            component: 'text',
            defaultValue: "Yay! You're getting free shipping!",
          },
        ],
      },
      {
        label: "Promotional Slider",
        name: 'promotionalSlider',
        component: 'group',
        fields: [
          {
            label: 'Enable Promotional Slider',
            name: 'enable',
            component: 'toggle',
            toggleLabels: {
              true: 'Enabled',
              false: 'Disabled',
            },
          },
          {
            label: 'Background Color',
            name: 'backgroundColorHex',
            component: 'color',
            defaultValue: '#B8C5D6',
          },
          {
            label: 'Text Color',
            name: 'textColor',
            component: 'select',
            options: [
              { label: 'White', value: 'text-white' },
              { label: 'Black', value: 'text-black' },
            ],
            defaultValue: 'text-black',
          },
          {
            label: 'Enable Auto Play',
            name: 'enableAutoplay',
            component: 'toggle',
            toggleLabels: {
              true: 'Enabled',
              false: 'Disabled',
            },
          },
          {
            label: 'Autoplay Speed',
            name: 'autoplaySpeed',
            component: 'number',
            description: 'Time each slide will stay in screen in seconds (if auto  play is enabled)',
            defaultValue: 5,
          },
          {
            label: 'Promotional Slide',
            name: 'slide',
            component: 'group-list',
            itemProps: {
              label: '{{item.text}}',
            },
            fields: [
              {
                label: "Customer Base",
                name: 'customerBase',
                component: 'select',
                options: [
                  { label: 'US only ', value: 'us' },
                  { label: 'International Only', value: 'intl' },
                  { label: 'All', value: 'all' },
                ],
                defaultValue: 'all',
              },
              {
                label: 'Slide Text',
                name: 'text',
                component: 'markdown',
                defaultValue: 'Promotional message'
              }
            ]
          }
        ]
      },
      {
        label: 'Upsell Products Label',
        name: 'upsellProductsLabel',
        component: 'text',
        defaultValue: 'You May Also Like',
      }
    ],
  },
  {
    label: 'Discount Highlight',
    name: 'discountHighlight',
    component: 'group',
    fields: [
      {
        label: 'Enable Discount Highlight',
        name: 'enableDiscountHighlight',
        component: 'toggle',
        toggleLabels: {
          true: 'Enabled',
          false: 'Disabled',
        },
        description:
          'If enabled, percentage difference between compare at price vs price will be shown on the mini cart and cart template, this will also enable this discount to be visible within the PDP',
      },
      {
        label: 'Cart Discount Message',
        name: 'cartDiscountMessage',
        component: 'text',
        defaultValue: 'Black Friday Savings',
      },
      {
        label: 'PDP discount message',
        name: 'pdpDiscountMessage',
        component: 'text',
        description:
          'Use the keyword [discount] to dynamically display the savings value, if this text is not populated the text will not be displayed',
        defaultValue: '[discount] OFF BLACK FRIDAY',
      },
    ],
  },
  {
    label: 'Search',
    name: 'search',
    component: 'group',
    fields: [
      {
        label: 'Terms heading',
        name: 'termsHeading',
        component: 'text',
        defaultValue: 'Popular Searches',
      },
      {
        label: 'Popular search terms',
        name: 'terms',
        component: 'group-list',
        itemProps: {
          label: '{{item.label}}',
        },
        defaultItem: () => ({
          id: generateId(),
          label: 'New term',
        }),
        fields: [
          {
            label: 'Term',
            name: 'label',
            component: 'text',
          },
        ],
        defaultValue: [
          { label: 'Moisturize', value: 'Moisturize' },
          { label: 'Strengthen', value: 'Strengthen' },
          { label: 'Repair', value: 'Repair' },
          { label: 'Treatment', value: 'Treatment' },
          { label: 'Charcoal', value: 'Charcoal' },
          { label: 'Refresh', value: 'Refresh' },
          { label: 'Shampoo', value: 'Shampoo' },
          { label: 'Conditioner', value: 'Conditioner' },
          { label: 'Leave-In', value: 'Leave-In' },
        ],
      },
      {
        label: 'Terms heading',
        name: 'productsHeading',
        component: 'text',
        defaultValue: 'Popular products',
      },
      {
        name: 'products',
        label: 'Popular products',
        component: 'group-list',
        description: 'Only add max of three products',
        itemProps: {
          label: '{{item.product.title}}',
        },
        fields: [
          {
            name: 'product',
            component: 'productSearch',
            label: 'Product',
          },
        ],
      },
    ],
  },
    {
    label: 'Collection Tile',
    name: 'collectionTile',
    component: 'group',
    fields: [
      {
        label: 'Promo Tile Campaigns',
        name: 'campaigns',
        component: 'group-list',
        itemProps: {
          label: '{{item.name}}',
        },
        fields: [
          {
            label: 'Enable',
            name: 'enabled',
            component: 'toggle',
            toggleLabels: {
              true: 'On',
              false: 'Off',
            },
          },
          {
            label: 'Name',
            name: 'name',
            component: 'text',
          },
          {
            label: 'Promo Tiles',
            name: 'promoTiles',
            component: 'group-list',
            itemProps: {
              label: '{{item.position}}: {{item.text.heading}}',
            },
            fields: [
              {
                label: 'Grid Position',
                name: 'position',
                component: 'number',
                description: 'Assigns grid order',
              },
              {
                label: 'Aspect Ratio',
                name: 'aspectRatio',
                component: 'select',
                options: [
                  { label: '1:1', value: 'aspect-[1/1]' },
                  { label: '4:5', value: 'aspect-[4/5]' },
                  { label: '3:4', value: 'aspect-[3/4]' },
                  { label: '2:3', value: 'aspect-[2/3]' },
                  { label: '9:16', value: 'aspect-[9/16]' },
                  { label: 'Fill', value: 'h-full' },
                ],
              },
              {
                label: 'Link',
                name: 'link',
                component: 'link',
                description: 'Makes the entire tile a clickable link',
              },
              {
                label: 'Image Settings',
                name: 'background',
                component: 'group',
                fields: [
                  {
                    label: 'Image Alt',
                    name: 'alt',
                    component: 'text',
                    description: 'Brief description of image',
                  },
                  {
                    label: 'Desktop Image',
                    name: 'd_image',
                    component: 'image',
                    description: '*Required. Recommended Image size for "Fill" setting: 674px x 1000px',
                  },
                  {
                    label: 'Mobile Image',
                    name: 'm_image',
                    component: 'image',
                    description: '*Required. Recommended Image size for "Fill" setting: 628px x 1528px',
                  },
                ],
              },
            ],
            defaultItem: {
              position: 5,
              aspectRatio: 'h-full',
            },
          },
          {
            label: 'Collection Handles',
            name: 'collections',
            component: 'list',
            description:
              'Add all collection handles that will run this campaign, e.g. "all", "best-sellers"',
            field: {
              component: 'text',
            },
          },
        ],
        defaultItem: {
          enabled: false,
          name: 'Campaign',
          promoTiles: [
            {
              position: 5,
              aspectRatio: 'h-full',
            },
          ],
          collections: ['all'],
        },
      },
    ],
  },
  {
    label: 'Subscriptions',
    name: 'subscriptions',
    component: 'group',
    fields: [
      {
        label: 'Free Shipping Text',
        name: 'freeShippingText',
        component: 'text',
        defaultValue: 'Free Shipping',
      },
      {
        label: 'Color Badge Text',
        name: 'colorBadgeText',
        component: 'text',
        defaultVlue: 'Most Popular!',
      },
      {
        label: 'Cancel Anytime Text',
        name: 'cancelText',
        component: 'text',
        defaultValue: 'Cancel anytime + membership perks.',
      },
    ],
  },
  {
    label: 'Free Product Scenarios',
    name: 'newFreeProducts',
    component: 'group',
    fields: [
      {
        label: 'Free Product Scenarios',
        name: 'gwpScenarios',
        component: 'blocks',
        templates: {
          buyXGetY: {
            label: 'Buy X Get Y',
            key: 'buyXGetY',
            fields: [
              {
                component: 'toggle',
                name: 'enabled',
                label: 'Enable Promotion',
                description: 'Disable this to pre-populate any promotion without getting it active on the site',
                toggleLabels: {
                  true: 'Yes',
                  false: 'No',
                },
                defaultValue: true,
              },
              {
                component: 'text',
                name: 'campaign',
                label: 'Gift Campaign',
                description: 'Unique identifier for the GWP promotion, this is required to allow managing individual GWPs',
                validate: {
                  required: true,
                }
              },
              {
                name: 'gwpProductQualify',
                label: 'Add This Product To Cart To Qualify For Gift (USD)',
                component: 'productSearch',
              },
              {
                name: 'enableSubQualify',
                label: 'Check to look for only subscription in cart',
                component: 'toggle',
                toggleLabels: {
                  true: 'Yes',
                  false: 'No',
                },
                defaultValue: false,
              },
              {
                name: 'gwpProduct',
                label: 'Gift With Purchase Product',
                component: 'productSearch',
              },
              {
                label: 'Add item to cart label',
                name: 'gwpAddBack',
                component: 'text',
                default: 'Add free gift',
                description:
                  'Label for the button that the customer uses to add the items back to their cart if they have opted out',
              },
            ]
          },
          spendXGetY: {
            label: 'Spend X Get Y',
            key: 'spendXGetY',
            fields: [
              {
                component: 'toggle',
                name: 'enabled',
                label: 'Enable Promotion',
                description: 'Disable this to pre-populate any promotion without getting it active on the site',
                toggleLabels: {
                  true: 'Yes',
                  false: 'No',
                },
                defaultValue: true,
              },
              {
                component: 'text',
                name: 'campaign',
                label: 'Gift Campaign',
                description: 'Unique identifier for the GWP promotion, this is required to allow managing individual GWPs',
                validate: {
                  required: true,
                }
              },
              {
                name: 'gwpProduct',
                label: 'Gift With Purchase Product',
                component: 'productSearch',
              },
              {
                label: 'Cart Spend To Qualify For Gift (USD)',
                name: 'gwpCartMinimum',
                component: 'number',
              },
              {
                label: 'Add item to cart label',
                name: 'gwpAddBack',
                component: 'text',
                default: 'Add free gift',
                description:
                  'Label for the button that the customer uses to add the items back to their cart if they have opted out',
              },
            ],
          },
          buyFromCollectionGetY: {
            label: 'Buy From Collection Get Y',
            name: 'buyFromCollectionGetY',
            key: 'buyFromCollectionGetY',
            fields: [
              {
                component: 'toggle',
                name: 'enabled',
                label: 'Enable Promotion',
                description: 'Disable this to pre-populate any promotion without getting it active on the site',
                toggleLabels: {
                  true: 'Yes',
                  false: 'No',
                },
                defaultValue: true,
              },
              {
                component: 'text',
                name: 'campaign',
                label: 'Gift Campaign',
                description: 'Unique identifier for the GWP promotion, this is required to allow managing individual GWPs',
                validate: {
                  required: true,
                }
              },
              {
                name: 'gwpCollectionQualify',
                label:
                  'Add products from this collection To Qualify For Gift (USD)',
                component: 'text',
                info: 'Enter collection handle',
              },
              {
                name: 'gwpProduct',
                label: 'Gift With Purchase Product',
                component: 'productSearch',
              },
              {
                label: 'Add item to cart label',
                name: 'gwpAddBack',
                component: 'text',
                default: 'Add free gift',
                description:
                  'Label for the button that the customer uses to add the items back to their cart if they have opted out',
              },
            ],
          },
          buySubscriptionGetY: {
            label: 'Buy Subscription Get Y',
            name: 'buySubscriptionGetY',
            fields: [
              {
                component: 'toggle',
                name: 'enabled',
                label: 'Enable Promotion',
                description: 'Disable this to pre-populate any promotion without getting it active on the site',
                toggleLabels: {
                  true: 'Yes',
                  false: 'No',
                },
                defaultValue: true,
              },
              {
                component: 'text',
                name: 'campaign',
                label: 'Gift Campaign',
                description: 'Unique identifier for the GWP promotion, this is required to allow managing individual GWPs',
                validate: {
                  required: true,
                }
              },
              {
                name: 'gwpAllSubsQualify',
                label: 'Enable All Subscription Products to Qualify for Gift (USD)',
                component: 'toggle',
                toggleLabels: {
                  true: 'Yes',
                  false: 'No',
                },
                defaultValue: false,
                description:
                  'Enables only subscription products to trigger free gift',
              },
              {
                name: 'gwpProduct',
                label: 'Gift With Purchase Product',
                component: 'productSearch',
              },
              {
                label: 'Add item to cart label',
                name: 'gwpAddBack',
                component: 'text',
                default: 'Add free gift',
                description:
                  'Label for the button that the customer uses to add the items back to their cart if they have opted out',
              },
            ],
          },
          buyBundleGetY: {
            label: 'Buy Bundle Get Gift',
            name: 'buyBundleGetY',
            fields: [
              {
                component: 'toggle',
                name: 'enabled',
                label: 'Enable Promotion',
                description: 'Disable this to pre-populate any promotion without getting it active on the site',
                toggleLabels: {
                  true: 'Yes',
                  false: 'No',
                },
                defaultValue: true,
              },
              {
                component: 'text',
                name: 'campaign',
                label: 'Gift Campaign',
                description: 'Unique identifier for the GWP promotion, this is required to allow managing individual GWPs',
                validate: {
                  required: true,
                }
              },
              {
                name: 'gwpProduct',
                label: 'Gift With Purchase Product',
                component: 'productSearch',
              },
              {
                name: 'gwpBundleCount',
                label: 'Qualifying bundle length',
                component: 'number',
                defaultValue: 0,
              },
              {
                component: 'productSearch',
                label: 'Qualifying product',
                name: 'gwpProductQualify',
                description: 'Product that needs to be in the bundle to trigger the free gift, if the bundle lenght is matched but the product is not in the bundle the gift will not be added',
              },
              {
                component: 'text',
                label: 'Qualify Message',
                name: 'gwpQualifyMessage',
                description: 'Message that will be displayed on a toast with confetti when the bundle qualifies for the gift',
                default: 'You\'ve got a free gift',
              },
              {
                label: 'Add item to cart label',
                name: 'gwpAddBack',
                component: 'text',
                default: 'Add free gift',
                description:
                  'Label for the button that the customer uses to add the items back to their cart if they have opted out',
              },
            ],
          },
          freeSamples: {
            label: 'Free Samples',
            name: 'freeSamples',
            fields: [
              {
                label: 'Enable Free Samples',
                name: 'enabled',
                component: 'toggle',
                toggleLabels: {
                  true: 'Yes',
                  false: 'No',
                },
              },
              {
                component: 'text',
                name: 'campaign',
                label: 'Gift Campaign (required)',
                description: 'Unique identifier for the GWP promotion, this is required to allow managing individual GWPs',
                validate: {
                  required: true,
                }
              },
              {
                name: 'gwpProduct',
                label: 'Free Sample Product',
                component: 'productSearch',
              },
              {
                label: 'Cart Spend To Qualify For Samples (USD)',
                name: 'samplesCartMinimum',
                component: 'number',
              },
              {
                label: 'Add item to cart label',
                name: 'gwpAddBack',
                component: 'text',
                default: 'Add Free Sample',
                description:
                  'Label for the button that the customer uses to add the items back to their cart if they have opted out',
              },
            ],
          }
        }
      }
    ]
  },
  {
    label: 'Account',
    name: 'account',
    component: 'group',
    fields: [
      {
        label: 'Refer A Friend Image',
        name: 'referFriendImage',
        component: 'image',
        description: 'Recommended Image Size: 1000 x 1000',
      },
      {
        label: 'Sign In Message',
        name: 'SignInMessage',
        component: 'text',
      },
    ],
  },
  {
    label: 'Social Share',
    name: 'socialShare',
    component: 'group',
    fields: [
      {
        label: 'Instagram',
        name: 'instagramLink',
        component: 'text',
      },
      {
        label: 'Facebook',
        name: 'facebookLink',
        component: 'text',
      },
      {
        label: 'You Tube',
        name: 'youTubeLink',
        component: 'text',
      },
      {
        label: 'Pinterest',
        name: 'pinterestLink',
        component: 'text',
      },
      {
        label: 'Twitter',
        name: 'twitterLink',
        component: 'text',
      },
      {
        label: 'Tik Tok',
        name: 'tikTokLink',
        component: 'text',
      },
    ],
  },
  {
    label: 'Buy with Prime',
    name: 'buyWithPrime',
    component: 'group',
    fields: [
      {
        label: 'Badges Location',
        name: 'bwpLocation',
        component: 'select',
        description:
          'For this feature to work the products must include the tag BWP, if no products include the tag beside of the options selected below they will not show',
        options: [
          {
            label: 'None (disabled)',
            value: 'disabled',
          },
          {
            label: 'Selected collections',
            value: 'local',
          },
          {
            label: 'Sitewide',
            value: 'global',
          },
        ],
      },
      {
        label: 'Collections',
        name: 'collectionList',
        component: 'list',
        description:
          'List of collections in which the badges will be show, badge will be shown on the PDP besides it being applied to any collection unless the Badges location option is set to disabled, this reference should match exactly with the Collection Name in order to work',
        field: {
          component: 'text',
        },
      },
    ],
  },
  {
    label: 'Theme Colors',
    name: 'themeColors',
    component: 'group',
    description: 'Theme colors',
    fields: [
      {
        label: 'Primary Color',
        name: 'primaryColor',
        component: 'text',
        description: 'Hex code representing the primary color',
        defaultValue: '#753064',
      },
      {
        label: 'Primary Color - Alt',
        name: 'primaryColorAlt',
        component: 'text',
        description: 'Hex code representing the primary alt color',
        defaultValue: '#62284F',
      },
      {
        label: 'Secondary Color',
        name: 'secondaryColor',
        component: 'text',
        description: 'Hex code representing the secondary color',
        defaultValue: '#4B806E',
      },
      {
        label: 'Secondary Color - Alt',
        name: 'secondaryColorAlt',
        component: 'text',
        description: 'Hex code representing the secondary alt color',
        defaultValue: '#3E6A5B',
      },
      {
        label: 'Tertiary Color',
        name: 'tertiaryColor',
        component: 'text',
        description: 'Hex code representing the tertiary color',
        defaultValue: '#96212F',
      },
      {
        label: 'Tertiary Color - Alt',
        name: 'tertiaryColorAlt',
        component: 'text',
        description: 'Hex code representing the tertiary alt color',
        defaultValue: '#A84B43',
      },
      {
        label: 'Quaternary Color',
        name: 'quaternaryColor',
        component: 'text',
        description: 'Hex code representing the quarternary color',
        defaultValue: '#2A7B84',
      },
      {
        label: 'Quaternary Color - Alt',
        name: 'quaternaryColorAlt',
        component: 'text',
        description: 'Hex code representing the quarternary alt color',
        defaultValue: '#256E74',
      },
      {
        label: 'Quinary Color',
        name: 'quinaryColor',
        component: 'text',
        description: 'Hex code representing the quinary color',
        defaultValue: '#305FBA',
      },
      {
        label: 'Quinary Color - Alt',
        name: 'quinaryColorAlt',
        component: 'text',
        description: 'Hex code representing the quinary alt color',
        defaultValue: '#4973C1',
      },
      {
        label: 'Senary Color',
        name: 'senaryColor',
        component: 'text',
        description: 'Hex code representing the senary color',
        defaultValue: '#DED8B1',
      },
      {
        label: 'Senary Color - Alt',
        name: 'senaryColorAlt',
        component: 'text',
        description: 'Hex code representing the senary alt color',
        defaultValue: '#E3DDBD',
      },
      {
        label: 'Air Dry Cream',
        name: 'stylersColorOne',
        component: 'text',
        description: 'Hex code representing the Air Dry Cream color',
        defaultValue: '#00A7B5',
      },
      {
        label: 'Sculpting Cream',
        name: 'stylersColorTwo',
        component: 'text',
        description: 'Hex code representing the Sculpting Cream color',
        defaultValue: '#8094DD',
      },
      {
        label: 'Texture Foam',
        name: 'stylersColorThree',
        component: 'text',
        description: 'Hex code representing the Texture Foam color',
        defaultValue: '#FF585D',
      },
      {
        label: 'Sleek Stick',
        name: 'stylersColorFour',
        component: 'text',
        description: 'Hex code representing the Sleek Stick color',
        defaultValue: '#D74388',
      },
      {
        label: 'Grey 1',
        name: 'greyOne',
        component: 'text',
        description: 'Hex code representing grey 1',
        defaultValue: '#F8F9FA',
      },
      {
        label: 'Grey 3',
        name: 'greyThree',
        component: 'text',
        description: 'Hex code representing grey 3',
        defaultValue: '#F4F7FA',
      },
      {
        label: 'Grey 4',
        name: 'greyFour',
        component: 'text',
        description: 'Hex code representing grey 4',
        defaultValue: '#DFDFDF',
      },
      {
        label: 'Grey 5',
        name: 'greyFive',
        component: 'text',
        description: 'Hex code representing grey 5',
        defaultValue: '#E9ECEF',
      },
      {
        label: 'Grey 7',
        name: 'greySeven',
        component: 'text',
        description: 'Hex code representing grey 7',
        defaultValue: '#A4A4A4',
      },
      {
        label: 'Grey 9',
        name: 'greyNine',
        component: 'text',
        description: 'Hex code representing grey 9',
        defaultValue: '#343A40',
      },
      {
        label: 'Pink 1',
        name: 'pinkOne',
        component: 'text',
        description: 'Hex code representing pink 1',
        defaultValue: '#E61A4F',
      },
      {
        label: 'Pink 2',
        name: 'pinkTwo',
        component: 'text',
        description: 'Hex code representing pink 2',
        defaultValue: '#EB80A8',
      },
      {
        label: 'Orange',
        name: 'orange',
        component: 'text',
        description: 'Hex code representing orange',
        defaultValue: '#FF4713',
      },
      {
        label: 'Purple',
        name: 'purple',
        component: 'text',
        description: 'Hex code representing purple',
        defaultValue: '#552E90',
      },
      {
        label: 'Cream',
        name: 'cream',
        component: 'text',
        description: 'Hex code representing cream',
        defaultValue: '#CEB4A8',
      },
      {
        label: 'Green',
        name: 'green',
        component: 'text',
        description: 'Hex code representing green',
        defaultValue: '#14A34A',
      },
      {
        label: 'Seafoam',
        name: 'seafoam',
        component: 'text',
        description: 'Hex code representing seafoam',
        defaultValue: '#00A19B',
      },
      {
        label: 'Blue 1',
        name: 'blueOne',
        component: 'text',
        description: 'Hex code representing blue 1',
        defaultValue: '#5B9AC5',
      },
      {
        label: 'Blue 2',
        name: 'blueTwo',
        component: 'text',
        description: 'Hex code representing blue 2',
        defaultValue: '#B8C5D6',
      },
      {
        label: 'Blue 2 Alt',
        name: 'blueTwoAlt',
        component: 'text',
        description: 'Hex code representing blue 2 alternative',
        defaultValue: '#5B7E96',
      },
      {
        label: 'Mint',
        name: 'mint',
        component: 'text',
        description: 'Hex code representing mint',
        defaultValue: '#9DD4CA',
      },
      {
        label: 'Error',
        name: 'error',
        component: 'text',
        description: 'Hex code representing error',
        defaultValue: '#D0021B',
      },
      {
        label: 'Success',
        name: 'success',
        component: 'text',
        description: 'Hex code representing success',
        defaultValue: '#218246',
      },
      {
        label: 'Black',
        name: 'black',
        component: 'text',
        description: 'Hex code representing the shade of black',
        defaultValue: '#212529',
      },
      {
        label: 'Yellow',
        name: 'yellow',
        component: 'text',
        description: 'Hex code representing the shade of yellow',
        defaultValue: '#EDE757',
      },
      {
        label: 'Brown',
        name: 'brown',
        component: 'text',
        description: 'Hex code representing the shade of brown',
        defaultValue: '#936953',
      },
      {
        label: 'Primary Button - Background',
        name: 'buttonPrimaryBG',
        description:
          'Sets the default background color for the primary buttons',
        component: 'select',
        options: [
          { label: 'Primary', value: 'primaryColor' },
          { label: 'Primary Alt', value: 'primaryColorAlt' },
          { label: 'Secondary', value: 'secondaryColor' },
          { label: 'Secondary Alt', value: 'secondaryColorAlt' },
          { label: 'Tertiary', value: 'tertiaryColor' },
          { label: 'Tertiary Alt', value: 'tertiaryColorAlt' },
          { label: 'Quaternary', value: 'quaternaryColor' },
          { label: 'Quaternary Alt', value: 'quaternaryColorAlt' },
          { label: 'Quinary', value: 'quinaryColor' },
          { label: 'Quinary Alt', value: 'quinaryColorAlt' },
          { label: 'Senary', value: 'senaryColor' },
          { label: 'Senary Alt', value: 'senaryColorAlt' },
          { label: 'Grey 1', value: 'greyOne' },
          { label: 'Grey 3', value: 'greyThree' },
          { label: 'Grey 5', value: 'greyFive' },
          { label: 'Grey 7', value: 'greySeven' },
          { label: 'Grey 9', value: 'greyNine' },
          { label: 'Black', value: 'black' },
        ],
        defaultValue: 'black',
      },
      {
        label: 'Primary Button - Background Hover',
        name: 'buttonPrimaryBGHover',
        description: 'Sets the hover background color for the primary buttons',
        component: 'select',
        options: [
          { label: 'Primary', value: 'primaryColor' },
          { label: 'Primary Alt', value: 'primaryColorAlt' },
          { label: 'Secondary', value: 'secondaryColor' },
          { label: 'Secondary Alt', value: 'secondaryColorAlt' },
          { label: 'Tertiary', value: 'tertiaryColor' },
          { label: 'Tertiary Alt', value: 'tertiaryColorAlt' },
          { label: 'Quaternary', value: 'quaternaryColor' },
          { label: 'Quaternary Alt', value: 'quaternaryColorAlt' },
          { label: 'Quinary', value: 'quinaryColor' },
          { label: 'Quinary Alt', value: 'quinaryColorAlt' },
          { label: 'Senary', value: 'senaryColor' },
          { label: 'Senary Alt', value: 'senaryColorAlt' },
          { label: 'Grey 1', value: 'greyOne' },
          { label: 'Grey 3', value: 'greyThree' },
          { label: 'Grey 5', value: 'greyFive' },
          { label: 'Grey 7', value: 'greySeven' },
          { label: 'Grey 9', value: 'greyNine' },
          { label: 'Black', value: 'black' },
        ],
        defaultValue: 'greyNine',
      },
      {
        label: 'Secondary Button - Background',
        name: 'buttonSecondaryBG',
        description:
          'Sets the default background color for the secondary buttons',
        component: 'select',
        options: [
          { label: 'Primary', value: 'primaryColor' },
          { label: 'Primary Alt', value: 'primaryColorAlt' },
          { label: 'Secondary', value: 'secondaryColor' },
          { label: 'Secondary Alt', value: 'secondaryColorAlt' },
          { label: 'Tertiary', value: 'tertiaryColor' },
          { label: 'Tertiary Alt', value: 'tertiaryColorAlt' },
          { label: 'Quaternary', value: 'quaternaryColor' },
          { label: 'Quaternary Alt', value: 'quaternaryColorAlt' },
          { label: 'Quinary', value: 'quinaryColor' },
          { label: 'Quinary Alt', value: 'quinaryColorAlt' },
          { label: 'Senary', value: 'senaryColor' },
          { label: 'Senary Alt', value: 'senaryColorAlt' },
          { label: 'Grey 1', value: 'greyOne' },
          { label: 'Grey 3', value: 'greyThree' },
          { label: 'Grey 5', value: 'greyFive' },
          { label: 'Grey 7', value: 'greySeven' },
          { label: 'Grey 9', value: 'greyNine' },
          { label: 'Black', value: 'black' },
        ],
        defaultValue: 'black',
      },
      {
        label: 'ATC Button - Background',
        name: 'buttonATCBG',
        description: 'Sets the default background color for the ATC buttons',
        component: 'select',
        options: [
          { label: 'Primary', value: 'primaryColor' },
          { label: 'Primary Alt', value: 'primaryColorAlt' },
          { label: 'Secondary', value: 'secondaryColor' },
          { label: 'Secondary Alt', value: 'secondaryColorAlt' },
          { label: 'Tertiary', value: 'tertiaryColor' },
          { label: 'Tertiary Alt', value: 'tertiaryColorAlt' },
          { label: 'Quaternary', value: 'quaternaryColor' },
          { label: 'Quaternary Alt', value: 'quaternaryColorAlt' },
          { label: 'Quinary', value: 'quinaryColor' },
          { label: 'Quinary Alt', value: 'quinaryColorAlt' },
          { label: 'Senary', value: 'senaryColor' },
          { label: 'Senary Alt', value: 'senaryColorAlt' },
          { label: 'Grey 1', value: 'greyOne' },
          { label: 'Grey 3', value: 'greyThree' },
          { label: 'Grey 5', value: 'greyFive' },
          { label: 'Grey 7', value: 'greySeven' },
          { label: 'Grey 9', value: 'greyNine' },
          { label: 'Black', value: 'black' },
        ],
        defaultValue: 'quinaryColor',
      },
      {
        label: 'ATC Button - Background Hover',
        name: 'buttonATCHoverBG',
        description: 'Sets the hover background color for the ATC buttons',
        component: 'select',
        options: [
          { label: 'Primary', value: 'primaryColor' },
          { label: 'Primary Alt', value: 'primaryColorAlt' },
          { label: 'Secondary', value: 'secondaryColor' },
          { label: 'Secondary Alt', value: 'secondaryColorAlt' },
          { label: 'Tertiary', value: 'tertiaryColor' },
          { label: 'Tertiary Alt', value: 'tertiaryColorAlt' },
          { label: 'Quaternary', value: 'quaternaryColor' },
          { label: 'Quaternary Alt', value: 'quaternaryColorAlt' },
          { label: 'Quinary', value: 'quinaryColor' },
          { label: 'Quinary Alt', value: 'quinaryColorAlt' },
          { label: 'Senary', value: 'senaryColor' },
          { label: 'Senary Alt', value: 'senaryColorAlt' },
          { label: 'Grey 1', value: 'greyOne' },
          { label: 'Grey 3', value: 'greyThree' },
          { label: 'Grey 5', value: 'greyFive' },
          { label: 'Grey 7', value: 'greySeven' },
          { label: 'Grey 9', value: 'greyNine' },
          { label: 'Black', value: 'black' },
        ],
        defaultValue: 'quinaryColorAlt',
      },
      {
        label: 'Checkout Button - Background',
        name: 'buttonCheckoutBG',
        description:
          'Sets the default background color for the Checkout buttons',
        component: 'select',
        options: [
          { label: 'Primary', value: 'primaryColor' },
          { label: 'Primary Alt', value: 'primaryColorAlt' },
          { label: 'Secondary', value: 'secondaryColor' },
          { label: 'Secondary Alt', value: 'secondaryColorAlt' },
          { label: 'Tertiary', value: 'tertiaryColor' },
          { label: 'Tertiary Alt', value: 'tertiaryColorAlt' },
          { label: 'Quaternary', value: 'quaternaryColor' },
          { label: 'Quaternary Alt', value: 'quaternaryColorAlt' },
          { label: 'Quinary', value: 'quinaryColor' },
          { label: 'Quinary Alt', value: 'quinaryColorAlt' },
          { label: 'Senary', value: 'senaryColor' },
          { label: 'Senary Alt', value: 'senaryColorAlt' },
          { label: 'Grey 1', value: 'greyOne' },
          { label: 'Grey 3', value: 'greyThree' },
          { label: 'Grey 5', value: 'greyFive' },
          { label: 'Grey 7', value: 'greySeven' },
          { label: 'Grey 9', value: 'greyNine' },
          { label: 'Black', value: 'black' },
        ],
        defaultValue: 'primaryColorAlt',
      },
      {
        label: 'Checkout Button - Background Hover',
        name: 'buttonCheckoutHoverBG',
        description: 'Sets the hover background color for the Checkout buttons',
        component: 'select',
        options: [
          { label: 'Primary', value: 'primaryColor' },
          { label: 'Primary Alt', value: 'primaryColorAlt' },
          { label: 'Secondary', value: 'secondaryColor' },
          { label: 'Secondary Alt', value: 'secondaryColorAlt' },
          { label: 'Tertiary', value: 'tertiaryColor' },
          { label: 'Tertiary Alt', value: 'tertiaryColorAlt' },
          { label: 'Quaternary', value: 'quaternaryColor' },
          { label: 'Quaternary Alt', value: 'quaternaryColorAlt' },
          { label: 'Quinary', value: 'quinaryColor' },
          { label: 'Quinary Alt', value: 'quinaryColorAlt' },
          { label: 'Senary', value: 'senaryColor' },
          { label: 'Senary Alt', value: 'senaryColorAlt' },
          { label: 'Grey 1', value: 'greyOne' },
          { label: 'Grey 3', value: 'greyThree' },
          { label: 'Grey 5', value: 'greyFive' },
          { label: 'Grey 7', value: 'greySeven' },
          { label: 'Grey 9', value: 'greyNine' },
          { label: 'Black', value: 'black' },
        ],
        defaultValue: 'primaryColorAlt',
      },
    ],
  },
];
